<template>
  <el-dialog
    :visible.sync="dialogFormVisible"
    width="750px"
    :before-close="close"
    :title="titles[updateType]"
  >
    <el-form ref="form" :model="initForm" :rules="rules">
      <template v-if="updateType === 'setting'">
        <el-checkbox-group v-model="initForm.menus">
          <el-checkbox
            style="width:300px;mrgin-right:20px;overflow:hidden;"
            v-for="menu in menuGroup"
            :label="menu.ID"
            :key="menu.ID"
            >{{ menu.Name }}</el-checkbox
          >
        </el-checkbox-group>
      </template>
      <template v-else>
        <el-form-item label="角色" prop="name" label-width="80px">
          <el-input v-model="initForm.name"></el-input>
        </el-form-item>
        <el-form-item label="描述" label-width="80px">
          <el-input v-model="initForm.desc"></el-input>
        </el-form-item>
        <!-- <el-form-item label="url授权" label-width="180px">
                    <el-select
                        v-model="initForm.menus"
                        multiple
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="item in menuGroup"
                            :key="item.ID"
                            :label="item.Name"
                            :value="item.ID"
                        >
                        </el-option>
                    </el-select>
                </el-form-item> -->
      </template>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    initForm: {},
    updateType: {}
  },
  data() {
    return {
      dialogFormVisible: true,
      rules: {
        name: [
          {
            required: true,
            message: "请输入角色名称",
            trigger: "blur"
          }
        ]
      },
      titles: {
        add: "新增角色",
        edit: "修改角色",
        setting: "权限设置"
      }
    };
  },
  computed: {
    menuGroup() {
      let menuGroup = this.$store.state.menuGroup;
      return menuGroup;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    // handleCheckAllChange(val) {
    //     this.checkedCities = val ? cityOptions : [];
    //     this.isIndeterminate = false;
    // },
    // handleCheckedChange(value) {
    //     let checkedCount = value.length;
    //     this.checkAll = checkedCount === this.cities.length;
    //     this.isIndeterminate =
    //         checkedCount > 0 && checkedCount < this.cities.length;
    // },
    submit() {
      this.$refs.form.validate(valid => {
        let from = Object.assign({}, this.initForm);
        if (!valid) return false;
        if (this.updateType === "edit" || this.updateType === "setting") {
          let url = "roles/" + from.id + "/";
          this.$http["put"](url, from, () => {
            this.$baseNotice.message("编辑成功");
            this.$emit("close");
            this.$emit("update");
          });
        } else if (this.updateType === "add") {
          let url = "roles/";
          this.$http["post"](url, from, () => {
            this.$baseNotice.message("新增成功");
            this.$emit("close");
            this.$emit("update");
          });
        } else {
          //setting
        }
      });
    }
  }
};
</script>
